// extracted by mini-css-extract-plugin
export default {"button":"dj-z","reviewSort":"ej-z"};